import { Dispatch, useContext, useState } from 'react'
import { InternalContext } from '../../contexts/InternalContext'
import { InterfaceEvent } from '../../../interfaces/InterfaceEvent'
import { useDrag } from '../../../hooks/useDrag'
import { useDocumentCursor } from '../../../hooks/useDocumentCursor'
import { useDisableUserSelect } from '../../../hooks/useDisableUserSelect'
import { validateVolume } from '../functions/validateVolume'
import { logVolumeChange } from '../../functions/logVolumeChange'

export function useVolumeControl(element: HTMLDivElement | null, setEditing: Dispatch<boolean>) {
  const {
    audioPlayer: { setVolume },
  } = useContext(InternalContext)
  const [initialRect, setInitialRect] = useState<DOMRect | null>(null)
  const update = ({ clientX }: InterfaceEvent, { left, width }: DOMRect) => {
    const ratio = (clientX - left) / width
    const next = validateVolume(ratio)

    logVolumeChange(next)
    setVolume(next)
  }

  useDrag(element, {
    onDown(event) {
      if (element) {
        const rect = element.getBoundingClientRect()

        setEditing(true)
        setInitialRect(rect)
        update(event, rect)
      }
    },
    onMove(event) {
      if (initialRect) {
        update(event, initialRect)
      }
    },
    onUp() {
      setEditing(false)
      setInitialRect(null)
    },
  })

  useDocumentCursor('ew-resize', initialRect)
  useDisableUserSelect(initialRect)
}
